<template>
    <default-button :color="color" size="xs" :icon="isLocked ? 'lock-closed' : 'lock-open'"
                    @click.native="$emit('click')"
    />
</template>

<script>
export default {
    props: {
        isLocked: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
        color() {
            if (this.isLocked) {
                return 'red';
            } else {
                return 'green';
            }
        },
    },
};
</script>
